import {Language} from "../../config/LanguageConfig";
import {LanguageActionTypes, SELECT_LANGUAGE} from "../../actions/common/GeneralSettingsActions";
import {German} from "../../config/languages/German";


export interface LanguageState {
    current: Language
}

const initialState = {
    current: German
};

export const GeneralSettingsReducer = (state = initialState, action: LanguageActionTypes ) => {
    switch( action.type ) {
        case SELECT_LANGUAGE:
            return {
                current: action.lang
            };
        default:
            return state;
    }

};